import { writeDB } from './store';
import { t } from '../locales/translate';

/* INTERFACES */
export interface Notification {
  id: string;
  title: string;
  message: string;
  status?: number;
  details?: string;
  url?: string;
  type: 'error' | 'success' | 'warning';
  closeAfter?: number;
}

interface AnyError extends Error {
  response?: {
    status: string;
    data: {
      detail: string;
    };
  };
  config?: {
    url: string;
  };
}

/* METHODS */
//Fixes the unknown can be asigned to type error
// eslint-disable-next-line
export function handleError(error: any, closeAfter?: number): void {
  const anyError: AnyError = error;
  const record = {
    title: [anyError.name, anyError.response && anyError.response.status].filter(Boolean).join(' '),
    message: anyError.response
      ? [anyError.config && anyError.config.url, anyError.response.data.detail].filter(Boolean).join(':')
      : error.message,
    type: 'error',
    closeAfter,
  };
  writeDB.table('notifications').insert(record);
  if (console) {
    // eslint-disable-next-line
    console.error(error);
  }
}

export function handleSuccess(
  notification:
    | string
    | {
        title?: string;
        message: string;
      },
  closeAfter = 3000
): void {
  const defaultTitle = t.general.success;
  writeDB.table('notifications').insert({
    title: typeof notification === 'string' ? defaultTitle : notification.title || defaultTitle,
    message: typeof notification === 'string' ? notification : notification.message,
    type: 'success',
    closeAfter,
  });
}
